import { IGlobalJobSearchFilterDTO } from 'wisestep-api';

export const dateBeforeDays = (days: number) => {
  const d = new Date();
  d.setDate(d.getDate() - days);
  return d.toISOString();
};

export const hotJobsDefaultQuery: IGlobalJobSearchFilterDTO = {
  isGlobal: true,
  includeJobWithoutVisa: true,
  title: null,
  company: null,
  companyEmail: null,
  locations: [],
  visa: null,
  page: 0,
  size: 50,
  postedFromDate: dateBeforeDays(30),
  postedToDate: new Date().toISOString(),
  sort: 'createdOn,desc',
  search: '',
};
